module.exports = __webpack_public_path__ + "img/logo.da2f2c8a.svg";